import { Component, OnInit, HostBinding, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  template: '',
  styles: [
    `
      :host 
        display: block
        width: var(--skeleton-width)
        height: var(--skeleton-height)
        background: var(--skeleton-background)
        border-radius: var(--skeleton-circle)

        &.pulse 
          animation: pulse 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite
          animation-delay: 0.5s
              
        @keyframes pulse 
          0% 
            opacity: 1

          50%
            opacity: 0.3
              
          100% 
            opacity: 1
    `,
  ],
  //styleUrls: ['skel'],
})
export class SkeletonLoaderComponent implements OnInit {
  @HostBinding('class.pulse') initalClass = true;
  @Input() width?: string;
  @Input() height?: string;
  @Input() background?: string;
  @Input() circle = false;
  @Input() className = '';

  constructor(private readonly host: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    const host = this.host.nativeElement;

    if (this.className) {
      host.classList.add(this.className);
    }

    host.style.setProperty('--skeleton-width', this.width ?? '100%');
    host.style.setProperty('--skeleton-height', this.height ?? '20px');
    host.style.setProperty('--skeleton-circle', this.circle ? '50%' : '');
    host.style.setProperty('--skeleton-background', this.background ?? 'rgb(239, 241, 246) no-repeat');
  }
}
